export const ASSET_BASE = "/riseconv/assets/"

export const CASE_ROUTES = [
  { id: "benz-dashboard", path: "/cases/benz-dashboard", file: "cases/benz-dashboard.html" },
  { id: "legal-ai", path: "/cases/legal-ai", file: "cases/legal-ai.html" },
  { id: "pig-ops", path: "/cases/pig-ops", file: "cases/pig-ops.html" },
  { id: "expert-qa-platform", path: "/cases/expert-qa-platform", file: "cases/expert-qa-platform.html" },
  { id: "secure-arena", path: "/cases/secure-arena", file: "cases/secure-arena.html" },
]

const LEGACY_CASE_PATHS = new Map(
  CASE_ROUTES.flatMap((route) => [
    [route.path, route],
    [`${route.path}.html`, route],
    [`/${route.file}`, route],
  ]),
)

const HOME_PAGE = { id: "home", path: "/", file: "index.html" }
const HOME_HASH_ALIASES = new Map([["#faults", "#breakpoints"]])

export function getPageByPath(path = "/") {
  const normalized = normalizePath(path)
  if (normalized === "/" || normalized === "/index.html") return HOME_PAGE

  return LEGACY_CASE_PATHS.get(normalized) || HOME_PAGE
}

export function normalizeSiteHref(href, basePath = globalThis.window?.location?.pathname || "/") {
  if (!href || isExternalHref(href)) return href
  if (href.startsWith("#")) return href

  const base = new URL(basePath, "https://riseconv.local")
  const url = new URL(href, base)
  const page = getPageByPath(url.pathname)
  const hash = HOME_HASH_ALIASES.get(url.hash) || url.hash

  if (page.id === "home") return `/${hash}`
  return `${page.path}${hash}`
}

export function rewriteAssetPath(path) {
  if (!path || isExternalHref(path) || path.startsWith(ASSET_BASE)) return path

  const cleanPath = path.replace(/^\.?\.\//, "").replace(/^\.?\//, "")
  if (!cleanPath.startsWith("assets/")) return path

  return `${ASSET_BASE}${cleanPath.slice("assets/".length)}`
}

function normalizePath(path) {
  const url = new URL(path || "/", "https://riseconv.local")
  return url.pathname.replace(/\/+$/, "") || "/"
}

function isExternalHref(href) {
  return /^(?:[a-z][a-z\d+.-]*:)?\/\//i.test(href) || /^(mailto|tel):/i.test(href)
}
